import moment from "moment";

import { authGet } from "@api";
import { TimeLookbackRange } from "@types";
import { calculateLookbackSeconds } from "@utils/calculateLookbackSeconds";

import { RuleAnalyticsResponse, RulesEventType } from "@pages/overview/types";

const RULES_PAGE_SIZE = 5;

export const fetchRuleStats = (
  deploymentId: string,
  eventType: RulesEventType,
  timeLookbackRange: TimeLookbackRange,
  reposFilter: string[],
  until: number = moment().unix(),
  limit: number = RULES_PAGE_SIZE
): Promise<RuleAnalyticsResponse> => {
  const since = calculateLookbackSeconds(timeLookbackRange);
  const reposParam =
    reposFilter.length > 0 ? `&repo=${reposFilter.join(",")}` : "";
  return authGet<RuleAnalyticsResponse>(
    `/api/agent/deployments/${deploymentId}/analytics/rules?event=${eventType}&since=${since}&until=${until}&limit=${limit}${reposParam}`
  );
};
